// Reducer for the Discord webhook master-detail form cluster. `viewMode` (list vs
// edit), the id being edited, and the two text fields all change together as the
// user navigates between the webhook list and the add/edit form. Consolidating
// them removes separate-render churn react-doctor/prefer-useReducer flags.

export const makeInitialWebhookForm = (integrationId) => ({
    viewMode: integrationId === 'discord' ? 'list' : 'edit',
    editingWebhookId: null,
    name: '',
    url: '',
});

export function webhookFormReducer(state, action) {
    switch (action.type) {
        case 'SET_FIELD':
            return { ...state, [action.field]: action.value };
        case 'MERGE':
            return { ...state, ...action.values };
        default:
            return state;
    }
}
